<template>
  <div class="full-page-width">
    <div class="drafts relative">
      <div class="add-button c-float m-b-20 flex is-flex-wrap">
        <div class="flex" style="flex-grow: 1">
          <p class="user-name">{{ $t('not_planned_pickup') }}</p>
        </div>
        <Dropdown
          class="float-right drop-right"
          :buttonText="$t('add')"
          :dropdownOptions="dropdownOptions"
          @optionSelected="optionSelected" />
      </div>
      <DataTable
        :dropdown=false
        :tableHeader=false
        :tableHead=true
        tableAPI="NOT_PLANNED_PICKUPS"
        tableActions="NOT_PLANNED_PICKUPS"
        :totalCount="totalCount"
        :checkbox=false
        :type="type"
        :count="get_not_planned_pickup_count"
        :list="get_not_planned_pickup_list"
        :rowActionParameter="rowActionParameter"
        :filterOptions="filterOptions"
        :customTable="'NotPlannedPickups'"
        :updateIterator="updateIterator"
        @updatedSelections="tableSelectionsUpdated"
        @rowAction="rowAction" />
    </div>
    <Popup
      v-if="showPickupPopup"
      min-height="400px"
      :popupLarge=true
      :showConfirmButton="false"
      @cancel="togglePickupPopup">
      <template v-slot:header>
        <h2>{{ $t('pre_order_pickup') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12 m-b-20">
            <div class="row m-b-input">
              <div class="col-xs-5">
                <Calendar
                  :label="$t('pickup_date')"
                  v-model="pickupData.pickupDate"
                  :rules="{required: true}" />
              </div>
              <div class="col-xs-7">
                <InputText
                  v-cloak
                  v-model="pickupData.reference"
                  :label="$t('reference')"
                  :rules="{required: false}"
                />
              </div>
            </div>
            <InputSelect
              :class="isForeignPickupLocation ? 'm-b-input' : ''"
              :label="$t('pickup_location')"
              v-model="pickupLocationId"
              @change="checkForForeign"
              :countryFlag="true"
              :options="pickupLocationOptions"
            />
            <div class="row" v-if="isForeignPickupLocation">
              <div class="col-xs-6 m-b-20">
                <InputText
                  :label="$t('company_name')"
                  v-model="pickupData.company"
                  :rules="{required: true}" />
              </div>
              <div class="col-xs-6 m-b-20">
                <InputText
                  :label="$t('name')"
                  v-model="pickupData.attention"
                  :rules="{required: false}" />
              </div>
            </div>
            <AddressPicker
              class="m-b-input"
              v-if="isForeignPickupLocation"
              :label="$t('address_1')"
              placeholder="Search address"
              @addressSelected="changeAddress('pickup', $event)"
              v-model="pickupAddress"
            />
          </div>
        </div>
        <div class="row" v-if="isForeignPickupLocation">
          <div class="col-xs-6">
            <PhoneSelect v-model="pickupData.phone" :rules="{required: false}" />
          </div>
          <div class="col-xs-6">
            <InputText
              label="Email"
              v-model="pickupData.email"
              :rules="{required: false, email: false}" />
          </div>
        </div>
        <div class="m-r-20 m-t-40">
          <div class="d-inline-block m-r-20">
            <Toggle
                class="m-r-10"
                id="show_add_manual_shipment"
                v-model="showManualShipmentBlock"
                @change="resetShipments"
            />
            {{ $t('add_manual_shipments_row') }}
          </div>
          <ManualShipmentsBlock class="p-t-20"
            v-if="showManualShipmentBlock"
            v-model="pickupShipments "/>
        </div>
      </div>
      <!-- Products -->
      <message v-if="!productCardDataValid" name="warning" :data="data={data: this.productCardErrorMessage, type:'validation'}"></message>
      <div v-if="!reloadingProducts && productCardDataValid">
        <h2 class="m-b-20 p-t-30 section-title">{{ $t('pickup_options_on_this_address') }}</h2>
        <ProductCard
          v-for="(product, index) in productsList"
          :key="`product-${product.shipping_product_id}-${index}`"
          :product="product"
          :pickupLocationId="pickupLocationId"
          :pickupDate="pickupData.pickupDate"
          :pageType="'index'"
          :isOpened="(selectedProduct != null) && (selectedProduct.shipping_product_id == product.shipping_product_id)"
          :disableButton="disableButton"
          :loadingButton="loadingButton"
          @bookPickup="bookPickup"
          @selected="selectProduct" />
      </div>
    </Popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import DataTable from '@/components/table/index.vue';
import Popup from '@/components/global/popup';
import Dropdown from '@/components/global/dropdown';
import ProductCard from '@/components/pickup/productCard';
import ManualShipmentsBlock from '@/components/pickup/manualShipmentsBlock';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import PickupMixin from '@/mixins/bookPickupPopup.js';

/* eslint-disable */
export default {
  name: 'NotPlannedPickups',
  mixins: [PickupMixin],
  components: {
    DataTable,
    Btn,
    Popup,
    InputText,
    InputSelect,
    Toggle,
    AddressPicker,
    PhoneSelect,
    Calendar,
    ManualShipmentsBlock,
    ProductCard,
    Dropdown
  },
  data() {
    return {
      productCardDataValid: false,
      productCardErrorMessage: '',
      productsList: null,
      selectedProduct: null,
      reloadingProducts: false,
      pickupLocationOptions: [],
      cachedPickupLocation: {},
      pickupLocationId: null,
      isForeignPickupLocation: false,
      isPickupPopupSubmitDisabled: false,
      isTableAllSelected: false,
      showPickupPopup: false,
      showImportButton: false,
      updateIterator: 1,
      totalCount: 10,
      disableButton: false,
      loadingButton: false,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('View shipment')}`,
      },
      type: {
        type: false,
        data: 'status',
      },
      dropdownOptions: [
        {
          text: this.$t('pre_order_pickup'),
          subText: this.$t('pre_order_pickup_subtext'),
          icon: 'pointer',
        },
      ],
      actionsOptions: [
        {
          text: 'Copy to new',
          subText: 'Create with copied data',
          icon: 'fileCopies',
        },
        {
          text: 'Create EOD',
          subText: 'Create end of day',
          icon: 'delivery',
        },
        {
          text: 'Print waybills',
          subText: 'Print waybills',
          icon: 'printer',
        },
        {
          text: 'Cancel',
          subText: 'Cancel shipment',
          icon: 'deleteForever',
        },
        {
          text: 'Export data',
          subText: 'Export data',
          icon: 'cloudUpload',
        },
      ],
      waybillsPdfPath: '',
      exportDataPath: '',
    };
  },
  computed: {
    tableType() {
      return 'BookedPickups';
    },
    ...mapGetters([
      'get_not_planned_pickup_list',
      'get_not_planned_pickup_count',
      'get_active_subaccount',
      'get_pickup_locations',
      'get_error_message',
      'get_filters_menu',
      'get_active_filter',
      'get_all_shipments_query'
    ]),
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'notPlannedPickups',
        tableApi: 'not-planned-pickup/get-list',
        filterFields: {
          sender_address: {
            label: `${this.$t('pickup_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          ship_date: {
            label: this.$t('pickup_date'),
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          subaccounts: {
            label: this.$t('account'),
            type: 'subaccount',
            value: {
              value: [],
              additional: '',
            },
          },
          goods_type: {
            label: this.$t('goods_type'),
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('parcel')}`, value: '1'},
              {text: `${this.$t('document')}`, value: '2'},
              {text: `${this.$t('pallet')}`, value: '3'},
              {text: `${this.$t('load')}`, value: '4'},
            ],
          },
          dangerous_goods: {
            label: `${this.$t('dangerous_goods')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
        }
      }
    },
  },
  methods: {
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.openCreatePickupPopup();
      }
    },
    togglePickupPopup() {
      this.showPickupPopup = !this.showPickupPopup;
    },
    // Table actions
    tableSelectionsUpdated(val) {
      this.isTableAllSelected = val.selectTotalRows;
    },
    rowAction(val) {
      this.$router.push(`/pickups/not-planned/${val}`);
    },
    bookPickup(childData) {
      const payload = {
        is_preorder: true,
        allowed_awbs: childData.product.allowed_shipment_awbs,
        subaccount_id: this.get_active_subaccount.id,
        pickup_date: this.pickupData.pickupDate,
        reference: this.pickupData.reference,
        pickup_time_zone: childData.pickup_time_zone,
        pickup_time_from: childData.pickup_time_from,
        pickup_time_until: childData.pickup_time_until,
        pickup_driver_note: childData.pickup_driver_note,
        shipping_product_id: childData.product.shipping_product_id,
        address: this.getRequestFormattedAddress(),
        shipments: this.getRequestFormattedShipments()
      }

      this.disableButton = true;
      this.loadingButton = true;
      this.$store.dispatch('BOOK_PICKUP', payload).then(() => {
        this.togglePickupPopup();
        this.updateIterator++;
      }).finally(() => {
        this.disableButton = false;
        this.loadingButton = false;
      });
    }
  },
  mounted() {
    this.isForeignPickupLocation = true;
  },
  watch: {
    observableObject: {
      handler(newVal, oldVal){
        if(this.popupDataIsValid()){
          this.makeCall();
        }
      },
      deep: true
    },
  }
};
</script>
